var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    filter: "url(#filter0_i_2661_212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Logo",
    d: "M28.8558 20.2357C28.876 20.6954 28.4336 21.1814 27.8391 21.505L27.3924 21.7223C27.2755 21.7793 27.0819 21.764 26.9586 21.7179L14.4576 17.0245C14.4576 17.0245 14.4565 17.0234 14.4554 17.0234L14.448 17.0201C14.4406 17.0168 14.4278 17.0124 14.4129 17.0069C14.4065 17.0047 14.3991 17.0015 14.3906 16.9982C14.3895 16.9982 14.3874 16.9971 14.3863 16.9971C14.2438 16.9433 13.9195 16.8128 13.6302 16.6131C13.4473 16.4869 13.2154 16.465 13.0187 16.5659L12.3647 16.8994L11.6841 17.2417C11.2034 17.4831 11.4469 18.284 11.9489 18.4727L16.4781 20.1666L23.9085 22.9609C24.1042 23.0355 24.117 23.3186 23.9288 23.4107L21.2488 24.7152C21.1095 24.7832 20.8437 24.7514 20.7001 24.6965L8.39053 20.0755C8.38203 20.0722 8.36394 20.0657 8.33948 20.0558C8.3331 20.0536 8.32672 20.0514 8.31928 20.0481C8.30439 20.0426 8.28844 20.036 8.27143 20.0294C8.11191 19.968 7.82584 19.8462 7.56635 19.6674C7.38025 19.539 7.14415 19.5182 6.94315 19.6202L6.29657 19.9494L5.61596 20.2917C5.13527 20.533 5.34265 21.3207 5.84354 21.5094L6.34975 21.6981L11.8563 23.7607L17.6224 25.9286C17.8585 26.0174 17.8723 26.3575 17.6458 26.4683L16.0304 27.2549C15.2701 27.6247 14.4161 27.6653 13.6259 27.3679L11.096 26.4168L2.50321 23.1935C-0.49469 21.9636 -0.329847 19.3503 1.29937 18.5747L9.54013 14.6515L9.56034 14.6416L11.4576 13.742C11.8096 13.5379 11.8191 13.1726 11.8138 13.0618C11.8074 12.9466 11.7574 12.5604 11.3469 12.4057L0.865487 8.46382C0.447547 8.30694 0.164663 7.90759 0.144457 7.44681C0.125315 6.98603 0.409257 6.54719 1.12603 6.19502L1.60778 5.96024C1.72582 5.90319 1.92363 5.91965 2.04593 5.96573L15.0669 10.8621C15.0669 10.8621 15.068 10.8621 15.0712 10.8632L15.0786 10.8665C15.0829 10.8687 15.0903 10.8709 15.0978 10.8741C15.2158 10.9224 15.5902 11.0815 15.8783 11.3009C16.0581 11.437 16.2974 11.4578 16.5005 11.3613L16.7036 11.2658L17.1545 11.053L17.8798 10.7118C18.37 10.4803 18.1382 9.67063 17.6331 9.47754L7.06971 5.43473L5.12464 4.70296C4.9279 4.62946 4.91621 4.34531 5.10444 4.25316L7.70566 2.9871C7.84497 2.91908 8.08638 2.94212 8.23102 2.99697L21.3137 7.91747C21.3137 7.91747 21.3169 7.91856 21.3233 7.92076L21.3318 7.92405C21.4179 7.95806 21.804 8.11714 22.1315 8.3585C22.3123 8.49125 22.5494 8.5099 22.7504 8.41445L22.9493 8.3201L22.9674 8.31242C22.9706 8.31133 22.9748 8.30913 22.9812 8.30584L23.4002 8.10836C23.4045 8.10617 23.4066 8.10507 23.4077 8.10507L24.1733 7.74412C24.6657 7.51154 24.4307 6.69969 23.9234 6.50879L13.6536 2.64481L11.1725 1.71227C10.996 1.64535 10.9854 1.39082 11.1555 1.30854L12.9241 0.447316C13.6855 0.0775935 14.5384 0.0359028 15.3285 0.333217L21.2393 2.55594L26.4226 4.50549C29.714 5.70462 29.2014 8.46492 27.5988 9.26141L25.7526 10.1797L23.6905 11.1923L23.0142 11.5335L22.1177 11.9866L17.9266 14.0996C17.5831 14.3048 17.5735 14.6646 17.5788 14.7743C17.5852 14.8895 17.6352 15.2757 18.0457 15.4304L28.1337 19.2154C28.5537 19.3756 28.8366 19.7738 28.8558 20.2357Z",
    fill: "url(#paint0_linear_2661_212)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2661_212",
    x: 0.143555,
    y: 0.136719,
    width: 28.7129,
    height: 27.4277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.129922
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996667 0 0 0 0 1 0 0 0 0 0.833333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2661_212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2661_212",
    x1: 14.5,
    y1: 0.136719,
    x2: 14.5,
    y2: 27.5649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#C9C0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#838996"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a0d122a70b3db8bb8de6d184441c3af7.svg";
export { ForwardRef as ReactComponent };